<script setup>
import { ref, computed, watch } from "vue";

// const props = defineProps(["data", "currentPage", "pageSize", "visibleData"]);
const props = defineProps({
  data: {
    type: Array,
    default: () => [],
  },
  currentPage: {
    type: Number,
    default: 0,
  },
  pageSize: {
    type: [String, Number],
    default: 10,
  },
  visibleData: {
    type: Array,
    default: () => [],
  },
  showSizes: {
    type: Boolean,
    default: false,
  },
  fromCompliance: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["page:update", "query", "size"]);

const queryFunc = () => {
  emit("query");
};

const activePage = ref(0);

const startItem = computed(() => {
  return props.currentPage * Number(props.pageSize) + 1;
});

const endItem = computed(() => {
  const lastItem = (props.currentPage + 1) * Number(props.pageSize);
  return Math.min(lastItem, props.data.length);
});

const updatePage = (pageNumber) => {
  console.log(pageNumber, "PN", props.currentPage);
  activePage.value = pageNumber + 1;
  emit("page:update", pageNumber, props.data);
  queryFunc();
};

// const currentPage = ref(1);
// const totalItems = 100; // Change this value according to your total number of items

const totalPages = computed(() =>
 Math.ceil(props.data.length / Number(props.pageSize))||1
);
console.log(totalPages.value, "TP");

const visiblePages = computed(() => {
  const startPage = Math.max(2, props.currentPage);
  const endPage = Math.min(startPage + 2, totalPages.value - 1);
  return Array.from(
    { length: endPage - startPage + 1 },
    (_, i) => startPage + i
  );
});

function goToPage(page) {
  if (page >= 1 && page <= totalPages.value) {
    props.currentPage = page;
  }
}

const showPreviousLink = () => {
  return props.currentPage == 0 ? false : true;
};
const showNextLink = () => {
  return props.currentPage == totalPages.value - 1 ? false : true;
};
const jumpToLastPage = () => {
  updatePage(totalPages.value - 1);
};
const jumpToFirstPage = () => {
  updatePage(0);
};
const selectedSize = ref(15);

function changeSize(e) {
  selectedSize.value = e.target.value;
  emit("size", Number(selectedSize.value));
}
const watchSize = computed(() => props.pageSize);
watch(watchSize, (val) => {
  selectedSize.value = val;
});
</script>

<template>
  <div class="flex items-center gap-2 font-medium text-lg">
    <span class="text-[14px] text-[#231F1F] font-bold">Page</span>
    
    <!-- Current Page Number -->
    <div class="w-[30px] h-[30px] text-[#231F1F] text-[14px] flex items-center justify-center rounded-[8px] border border-[#E9E9E9]">
      {{ currentPage + 1 }}
    </div>

    <span class="text-[14px] text-[#231F1F]">of</span>

    <!-- Total Pages -->
    <div class="w-[30px] h-[30px] text-[#231F1F] text-[14px] flex items-center justify-center rounded-[8px] border border-[#E9E9E9]">
      {{ totalPages }}
    </div>

    <!-- Navigation Buttons -->
    <button 
       @click="updatePage(currentPage - 1)"
      :class="[
        'w-[24px] h-[24px] focus:outline-none rounded-tl-[8px] rounded-bl-[8px] flex items-center justify-center ml-4',
          currentPage === 1 
          ? 'bg-[#F3F3F3] text-[#8B8B8B] cursor-not-allowed' 
          : 'bg-[#D9EBCD] text-[#000] hover:bg-[#D9EBCD]'
      ]"
      :disabled="currentPage === 1"
    >
      <svg 
        width="16" 
        height="16" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round"
      >
        <path d="M15 18l-6-6 6-6" />
      </svg>
    </button>

    <button 
       @click="updatePage(currentPage + 1)"
      :class="[
        'w-[24px] h-[24px] focus:outline-none rounded-tr-[8px] rounded-br-[8px] flex items-center justify-center',
        currentPage === totalPages 
          ? 'bg-[#F3F3F3] text-[#8B8B8B] cursor-not-allowed' 
          : 'bg-[#D9EBCD] text-[#000] hover:bg-[#D9EBCD]'
      ]"
      :disabled="currentPage === totalPages"
    >
      <svg 
        width="16" 
        height="16" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round"
      >
        <path d="M9 18l6-6-6-6" />
      </svg>
    </button>
  </div>
</template>
